<template>
    <div class="Outer-frame">
        <el-container style="min-width:1280px;">
            <el-main>
                <div class="main-header">
                    <div class="abchcha">
                        关于我们
                    </div>
                    <div class="abencha">
                        About us
                    </div>
                </div>
                <div class="main-middle">
                    <div class="ourstory">
                        <div class="ourstory-left">

                        </div>
                        <div class="ourstory-right">
                            <div class="storycontent" style="margin-top: 112px;">
                                Mobii！隶属广东莫比科技有限公司，成立于2018年8月，是一家基于交通大数据为优势，以AI技术整合交通+旅游+电商的互联网科技公司。
                            </div>
                            <div class="storycontent" style="margin-top: 12px;">
                                公司拥有精湛的研发能力和成熟的跨境业务扩展能力，主要面向商家或企业提供跨境交通卡，漫游流量，电商，营销，支付，CRM，AI客服一站式SaaS平台。
                            </div>
                            <div class="storycontent" style="margin-top: 12px;">
                                目前，公司已整合亚洲范围内的交通，旅游，电商资源，面向广大用户推出“ Mobii！”APP，致力于打造跨境会员制旅游生活电商平台，逐步满足亚洲用户本地及跨境「食、住、行、游、购、娱」需求。
                            </div>
                            <div class="storycontent" style="margin-top: 12px;">
                                公司拥有两大自主品牌，Mobii！APP和Justka智能客服，下设研发部、产品部、商务部，高效的团队协作能力，为广大企业伙伴和用户提供成熟的软、硬件服务。
                            </div>
                        </div>
                    </div>
                    <div class="ourservices">
                        <div class="ourservices-header">
                            <div class="ourservices-header-title">
                                <div class="ourservices-header-titlechcha">
                                    我们的服务
                                </div>
                                <div class="ourservices-verticallinea">

                                </div>
                                <div class="ourservices-header-titleencha">
                                    Our services
                                </div>
                            </div>
                            <div class="ourservices-header-titlecontent">
                                <p>为用户提供高品质的「食、住、行、游、购、娱」一站式精准服务</p>
                            </div>
                        </div>
                            <div class="ourservices-middle">
                                <p class="ourservices-middle-pa">
                                    “Mobii!”由广东莫比科技有限公司和南京莫比旅游科技有限公司联合开发，定位“交通+旅游+电商”，是一款提供跨境会员制旅游生活电商服务的APP，于2020年在中国南京和中国台湾上线。
                                </p>
                                <p>
                                     主要针对用户对出行、购物和追求品质生活的需求，以“自营+平台”的模式，推出多品类高品质服务，包括酒店、门票、美食、休闲玩乐、旅游（周边游、当地游）、机票、购物等。
                                </p>
                            </div>
                        <div>

                            <div class="ourservicesbottom">
                                <div class="ourservicesbottom-list">
                                    <img src="../assets/images/mobiigw/jtfw.png" alt="">

                                    <p class="ourservices-chcha">交通服务</p>

                                    <p class="ourservices-chchb1">实现跨国交通不换卡，真正的“亚洲一卡通”</p>
                                </div>
                                <div class="ourservicesbottom-list">
                                    <img src="../assets/images/mobiigw/lyfw.png" alt="">

                                    <p class="ourservices-chcha">旅游服务</p>

                                    <p class="ourservices-chchb2">实现亚洲旅游资源全覆盖</p>
                                </div>
                                <div class="ourservicesbottom-list">
                                    <img src="../assets/images/mobiigw/shfw.png" alt="">

                                    <p class="ourservices-chcha">生活服务</p>

                                    <p class="ourservices-chchb3">整合各品类的商户服务，满足用户在当地的生活需求，实现“本地生活一卡通”</p>
                                </div>
                                <div class="ourservicesbottom-list">
                                    <img src="../assets/images/mobiigw/ydzf.png" alt="">

                                    <p class="ourservices-chcha">跨境移动支付</p>

                                    <p class="ourservices-chchb4">建立方便快捷，安全的亚洲跨境移动支付解决方案</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-main>
            <el-footer>
                <div class="ourvision">
                    <div class="ourvisionheader">
                       <img src="../assets/images/mobiigw/yuanjing.png" alt="">
                    </div>
                    <div class="ourvisionbottom">
                        <div class="ourvisionbottom-list">
                            <img src="../assets/images/mobiigw/service.png" alt="">

                            <p class="ourvision-chcha">服务至上</p>

                            <p class="ourvision-encha">Service-oriented</p>
                        </div>
                        <div class="ourvisionbottom-list">
                            <img src="../assets/images/mobiigw/detail.png" alt="">

                            <p class="ourvision-chcha">高标准重细节</p>

                            <p class="ourvision-encha">Detail & Highest Standard</p>
                        </div>
                        <div class="ourvisionbottom-list">
                            <img src="../assets/images/mobiigw/key.png" alt="">

                            <p class="ourvision-chcha">关键结果为导向</p>

                            <p class="ourvision-encha">Key results oriented</p>
                        </div>
                        <div class="ourvisionbottom-list">
                            <img src="../assets/images/mobiigw/social.png" alt="">

                            <p class="ourvision-chcha">为社会尽责</p>

                            <p class="ourvision-encha">Social responsibility</p>
                        </div>
                    </div>
                </div>
                <div class="ourculture">
                    <div class="ourculture-header">
                        <div class="ourculture-title-one">
                            <div class="ourculture-chcha">
                                我们的文化
                            </div>
                            <div class="ourculture-verticalline">

                            </div>
                            <div class="ourculture-encha">
                                Our Culture
                            </div>
                        </div>
                    </div>
                    <div class="ourculture-middle">
                        <div class="ourculture-button">
                            <p class="ourculture-title-two">乐在其中，持续前进</p>
                        </div>
                    </div>
                    <div class="ourculture-buttom">
                        <div class="ourculture-buttom-header">
                            <div class="och-1">
                                <img src="../assets/images/mobiigw/diverse.png" alt="">

                                <p class="chcha">正向多元思考</p>

                                <p class="encha">Positive & Diverse</p>
                            </div>
                            <div class="och-2">
                                <img src="../assets/images/mobiigw/learn.png" alt="">

                                <p class="chcha">保持好奇心与学习</p>

                                <p class="encha">Curious & Learn</p>
                            </div>
                            <div class="och-3">
                                <img src="../assets/images/mobiigw/fun.png" alt="">

                                <p class="chcha">充满乐趣与热情</p>

                                <p class="encha">Fun & Passionate</p>
                            </div>
                            <div class="och-4">
                                <img src="../assets/images/mobiigw/ask.png" alt="">

                                <p class="chcha">勇敢提问直接沟通</p>

                                <p class="encha">Ask & Communicate</p>
                            </div>
                        </div>
                        <div class="ourculture-buttom-bottom">
                            <div class="ocb-1">

                                <img src="../assets/images/mobiigw/open mind.png" alt="">

                                <p class="chcha">协作及开放心态</p>

                                <p class="encha">Collaborate & Open Mind</p>

                            </div>
                            <div class="ocb-2">

                                <img src="../assets/images/mobiigw/creativity.png" alt="">

                                <p class="chcha">持续创新及天马行空</p>

                                <p class="encha">Innovation & Creativity</p>

                            </div>
                            <div class="ocb-3">

                                <img src="../assets/images/mobiigw/hardwork.png" alt="">

                                <p class="chcha">团队合作努力工作</p>

                                <p class="encha">Teamwork & Hardworking</p>

                            </div>
                            <div class="ocb-4">

                                <img src="../assets/images/mobiigw/failure.png" alt="">

                                <p class="chcha">快速行动并从错误中学习</p>

                                <p class="encha">Quick Action & Failure</p>

                            </div>
                        </div>
                    </div>
                </div>
                    <div class="footer">
                        <div class="footer-main">
                            <div class="footer-header">
                                <div class="footer-left">
                                    <div class="footer-left-title">
                                        联系我们
                                    </div>
                                    <div class="footer-left-content">
                                        联系电话：025-83728416
                                    </div>
                                    <div class="footer-left-content">
                                        官方微信：njmobii01
                                    </div>
                                    <div class="footer-left-content">
                                        官方邮箱：Mobii@justgoai.com
                                    </div>
                                </div>
                                <div class="footer-right">
                                    <div class="footer-right-title">
                                        关注我们
                                    </div>
                                    <div class="footer-right-content">
                                        <div class="footer-right-content-left">
                                            <img src="../assets/images/mobiigw/wechat.png" alt="">
                                            <p>APP下载</p>
                                        </div>
                                        <div class="footer-right-content-middle">
                                            <img src="../assets/images/mobiigw/gongzhonghao.png" alt="">
                                            <p>官方微信公众号</p>
                                        </div>
                                        <div class="footer-right-content-right">
                                            <img src="../assets/images/mobiigw/weibo.png" alt="">
                                            <p>官方微博</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="footer-middle">

                            </div>
                            <div class="footer-bottom">
                                <a href="http://beian.miit.gov.cn/" target="_blank">
                                   <p>版权所有 © 广东莫比科技有限公司 粤ICP备18159870号</p>
                                </a>
                            </div>
                        </div>
                    </div>
            </el-footer>
        </el-container>

    </div>
</template>
<script>
export default {
    data(){
        return{
            // activeIndex:'aboutus'
        }
    }
}
</script>
<style scoped>
    .Outer-frame{
        min-width: 1280px;
        margin: 0px;
        padding: 0px;
        flex-direction: column;
    }

    .main-header{
        width: 100%;
        height: 515px;
        display: flex;
        flex-direction: column;
        background-image: url('../assets/images/mobiigw/aboutus.png');
    }

    .abchcha{
        height:103px;
        font-size:74px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(19,51,76,1);
        line-height:103px;
        margin: 0 auto;
        margin-top: 183px;
    }

    .abencha{
        height:46px;
        font-size:46px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(19,51,76,1);
        line-height:46px;
        margin: 0 auto;
    }

    .main-middle{
        width: 71.11%;
        margin: 0 auto;

    }
    .ourstory{
        width: 100%;
        height: 510px;
        display: flex;
        margin-top: 90px;
    }

    .ourstory-left{
        width: 50%;
        height: 100%;
        background-image: url('../assets/images/mobiigw/image.png');
        background-position: center;
        background-size:cover;
    }

    .ourstory-right{
        display: flex;
        flex-direction: column;
        width: 50%;
        height: 100%;
        background:rgba(4,120,90,1);
        background-image: url('../assets/images/mobiigw/story.png');
        background-size:cover;
    }

    .storycontent{
        width:397px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:26px;
        margin: 0 auto;
    }

    .ourservices{
        width: 100%;
        /* height: 410px; */
        display: flex;
        flex-direction: column;
        margin-top: 90px;
    }

    .ourservices-header{
        width: 54%;
        /* border: 1px solid red; */
        display: flex;
        flex-direction: column;
        margin: 0 auto;
    }

    .ourservices-header-title{
        width: 65%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin:0 auto;
    }

    .ourservices-header-titlechcha{
        height:40px;
        font-size:24px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:40px;
    }

    .ourservices-header-titleencha{
        height:40px;
        font-size:28px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:40px;
    }

    .ourservices-header-titlecontent{
        width:500px;
        height:42px;
        background:rgba(95,208,132,1);
        border-radius:21px;
        margin: 30px auto;
    }

    .ourservices-header-titlecontent p{
        width:464px;
        height:22px;
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:42px;
        margin: 0 auto;
    }

    .ourservices-middle{
        margin: 0 auto;
    }

    .ourservices-middle-pa{
        margin-top: 30px;
    }

    .ourservices-middle p{
        width:921px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:26px;
        margin: 0;
        padding: 0;
    }

    .ourservices-verticallinea{
        height: 25px;
        width: 3px;
        background:rgba(165,165,165,1);
    }

    .ourservices-verticalline{
        height: 25px;
        width: 3px;
        background-color:rgba(255,255,255,1);
    }

    .ourvision{
        width: 100%;
        height: 482px;
        display: flex;
        flex-direction: column;
        margin-top: 90px;
        background-image: url('../assets/images/mobiigw/vision.png');
    }

    .ourvisionheader{
        display: flex;
        width: 100%;
        height: 100px;
        margin-top: 91px;
        margin-bottom: 60px;
    }

    .ourvisionheader img{
        margin: 0 auto;
    }

    .ourvisionbottom{
        width: 65%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 0 auto;
    }

    .ourvisionbottom-list{
        text-align: center;
    }

    .ourvision-chcha{
        height:22px;
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:22px;
    }

    .ourvision-encha{
        height:20px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(85,85,85,1);
        line-height:20px;
    }

    .ourculture{
        width:100%;
        height:710px;
        margin-top: 90px;
        background:rgba(95,208,132,1);
    }

    .ourculture-header{
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items:center;
        margin: 0 auto;
    }

    .ourculture-title-one{
        width: 26%;
        height: 40px;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items:center;
        margin-top: 78px;

    }

    .ourculture-chcha{
        height:40px;
        font-size:24px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:40px;
    }

    .ourculture-verticalline{
        height: 25px;
        width: 3px;
        background:rgba(255,255,255,1);
    }

    .ourculture-encha{
        height:40px;
        font-size:24px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:40px;
    }

    .ourculture-middle{
        width: 100%;
    }

    .ourculture-button{
        width:238px;
        height:42px;
        background:rgba(254,111,26,1);
        border-radius:21px;
        margin: 0 auto;
    }

    .ourculture-title-two{
        height:22px;
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:42px;
        text-align: center;
    }

    .ourculture-buttom{
        width: 65%;
        display: flex;
        flex-direction: column;
        margin: 0 auto;
        margin-top: 70px;
    }

    .ourculture-buttom-header{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        text-align: center;
        padding: 0;
        margin: 0;
    }

    .ourculture-buttom-bottom{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 30px;
        text-align: center;
    }

    .och-1,.och-2,.och-3,.och-4,.ocb-1,.ocb-2,.ocb-3,.ocb-4{
        width:200px;
        height:160px;
        background:rgba(255,255,255,1);
        box-shadow:0px 1px 4px 0px rgba(18,188,74,1);
        border-radius:4px;
        align-content: center;
        padding: 0;
    }

    .och-2,.och-3,.och-4,.ocb-2,.ocb-3,.ocb-4{
        margin-left: 30px;
    }

    .chcha{
        height:22px;
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:22px;
        margin-top: 15px;
        margin-bottom: 6px;
        padding: 0;
    }

    .encha{
        height:20px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(85,85,85,1);
        line-height:20px;
        margin: 0;
    }

    .ourculture-buttom img{
        margin-top: 29px;
        width:40px;
        height:40px;
        /* border-image:linear-gradient(143deg, rgba(254,111,26,1), rgba(255,59,48,1)); */
    }

    .el-main{
        padding: 20px 0 0 0;
    }

    .el-footer{
        padding: 0 0;
    }

    .footer{
        width: 100%;
        height: 343px;
        background:rgba(129,129,129,1);
    }

    .footer-main{
        width: 71.11%;
        display: flex;
        flex-direction: column;
        margin: 0 auto;
    }

    .footer-header{
        width: 100%;
        display: flex;
        flex-direction: row;
        margin: 0 auto;
    }

    .footer-left{
        width: 30%;
    }

    .footer-right{
        width: 70%;
    }

    .footer-left-title,.footer-right-title{
        height:30px;
        font-size:22px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:30px;
        margin-top: 44px;
    }

    .footer-left-content{
        height:20px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(221,221,221,1);
        line-height:20px;
        margin-top: 26px;
    }

    .footer-right-content{
        width: 70%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 26px 0 0 -26px;
    }

    .footer-right-content img{
        width: 94px;
        height: 94px;
    }

    .footer-right-content-left,.footer-right-content-middle,.footer-right-content-right{
        margin: 0 auto;
        text-align: center;
    }

    .footer-right-content-left,.footer-right-content-middle,.footer-right-content-right p{
        height:20px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:20px;
    }

    .footer-middle{
        width: 100%;
        height: 1px;
        background-color: #aaaaaa;
        margin-top: 1%;
        margin-bottom: 1%;
    }

    .footer-bottom{
        margin: 0 auto;
    }

    .footer-bottom p{
        text-align: center;
        height: 21px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(221,221,221,1);
        line-height: 21px;
    }

    .ourservicesbottom{
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        margin-top: 70px;
    }

    .ourservicesbottom-list{
        text-align: center;
    }


    .ourservices-chcha{
        height:22px;
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:22px;
    }

    .ourservices-chchb1{
        width:121px;
        height:48px;
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:24px;
        text-align: left;
    }

    .ourservices-chchb2{
        width:108px;
        height:48px;
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:24px;
        text-align: left;
    }

    .ourservices-chchb3{
        width:146px;
        height:72px;
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:24px;
        text-align: left;
    }

    .ourservices-chchb4{
        width:136px;
        height:72px;
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:24px;
        text-align: left;
    }

    a{
        text-decoration: none;
    }




</style>



// WEBPACK FOOTER //
// src/modules/aboutus.vue